import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import StethoscopeIcon from "components/Icons/Stethoscope";
import { transformViewDate } from "utils/date-utils";
import { getPersonFullName } from "utils/person";
import useStyles from "./styles";

interface IProps {
  data: racehorse360.IHorseAggregatedComment;
  className?: string;
}

const HorseFOTComment = (props: IProps) => {
  const {
    data: { commenterFirstName, commenterLastName, eventDate, body: content },
    className
  } = props;
  const classes = useStyles();

  const renderHeader = () => {
    return (
      <>
        <div className={classes.headerRow}>
          <span className={classes.commenterInfo}>
            <StethoscopeIcon className={classes.icon} />
            {getPersonFullName(
              { firstName: commenterFirstName, lastName: commenterLastName },
              "%f %M %L"
            )}
          </span>
        </div>
        <div className={classes.row}>
          <div className={classes.info}>
            <div className={classes.uppercase}>
              {transformViewDate(eventDate, null, "PP")}
            </div>
            <div className={classes.additionalSigns}>&nbsp;&ndash;&nbsp;</div>
            <div>{transformViewDate(eventDate, null, "p")}</div>
          </div>
        </div>
        <div className={classes.headerRow}>
          <h4>
            <span className={classes.colorFOT}>FOT</span>
            {" FLAGGED ON TRACK"}
          </h4>
        </div>
      </>
    );
  };

  return (
    <div className={clsx(classes.commentRoot, className)} tabIndex={0}>
      {renderHeader()}
      <div className={classes.commentContent}>{content}</div>
    </div>
  );
};

export default HorseFOTComment;
